import { setInternalServerErrorRenderer } from "./Hooks/ApiCall.fs.js";
import { PortalServerErrorNotification } from "./Components/Notification/PortalServerErrorNotification.fs.js";
import * as reset from "antd/dist/reset.css";
import * as dayjsSetup from "../src/Interop/dayjsSetup";
import * as oidc_client from "oidc-client";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "./fable_modules/Fable.React.9.4.0/Fable.React.FunctionComponent.fs.js";
import { some, value as value_2 } from "./fable_modules/fable-library-js.4.18.0/Option.js";
import { stringHash, int32ToString } from "./fable_modules/fable-library-js.4.18.0/Util.js";
import { routes, SigninRedirect, getCurrentUser } from "./Services/Auth/Auth.fs.js";
import * as react from "react";
import { defaultPage, Props, Controller } from "./Views/Portal.fs.js";
import { MissingClaimException } from "./Services/Auth/AuthUser.fs.js";
import { contains, ofArray, singleton, empty } from "./fable_modules/fable-library-js.4.18.0/List.js";
import { Context, UrlParamsStoreContext_$ctor } from "./Hooks/Query.fs.js";
import { Context as Context_1, useReactNotifications } from "./Services/Notifications/Notifications.fs.js";
import { NavProps, Location, RedirectFrom, Switch, Router } from "./Interop/ReactRouter.fs.js";
import { QueryParamProvider } from "./Interop/UseQueryParams.fs.js";
import { endpoint } from "./Services/Api/Api.fs.js";
import { printf, toText } from "./fable_modules/fable-library-js.4.18.0/String.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.2.2/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.2.2/PromiseImpl.fs.js";
import { unboxAndStringify, fetchAs } from "./Services/Api/ApiUtils.fs.js";
import { Types_RequestProperties, Types_HttpRequestHeaders } from "./fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { GuiUnhandledRejectionInfo, GuiExceptionInfo } from "./Loop54.Portal.Api.Model/GuiMonitoring.fs.js";
import { toString, isException } from "./fable_modules/fable-library-js.4.18.0/Types.js";
import { StyleProvider } from "@ant-design/cssinjs";
import * as client from "react-dom/client";
import { wrap } from "./Components/ErrorBoundary/ErrorBoundary.fs.js";

setInternalServerErrorRenderer((errorRecord) => PortalServerErrorNotification({
    portalError: errorRecord,
}));




export const AppAuthentication = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_2("/home/tcagent/agent/work/fc6800de859d0248/portal/Loop54.Portal.WebUI/src/App.fs") + "#L") + int32ToString(value_2(30))) + ";") + "Microsoft.FSharp.Collections.FSharpList`1[System.Tuple`2[System.String,System.Object]]", value_2("AppAuthentication"), (props) => {
    const user = getCurrentUser;
    const content = react.useState("Loading...");
    react.useEffect(() => {
        let pr_1;
        const pr = user();
        pr_1 = (pr.then((_arg) => {
            content[1]((_arg_1) => Controller(new Props(user, props.location.pathname)));
        }));
        pr_1.then(void 0, ((ex) => {
            if (ex instanceof MissingClaimException) {
                const claimEx = ex;
                content[1]((_arg_2) => {
                    let children_2;
                    const children_4 = [react.createElement("p", {}, "You could not be signed in."), (children_2 = [claimEx.message], react.createElement("p", {}, ...children_2))];
                    return react.createElement("div", {}, ...children_4);
                });
            }
            else {
                content[1]((_arg_3) => SigninRedirect(empty()));
            }
        }));
    }, []);
    return content[0];
}, undefined, undefined, "Of");

export const App = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_2("/home/tcagent/agent/work/fc6800de859d0248/portal/Loop54.Portal.WebUI/src/App.fs") + "#L") + int32ToString(value_2(63))) + ";") + "Microsoft.FSharp.Collections.FSharpList`1[System.Tuple`2[System.String,System.Object]]", value_2("App"), (props) => {
    let children_1, children;
    const cachedQueryParamsContext = UrlParamsStoreContext_$ctor();
    const patternInput = useReactNotifications({
        placement: "topRight",
    });
    return Router(empty(), singleton(QueryParamProvider(ofArray([patternInput[0], (children_1 = [(children = [Switch(empty(), ofArray([RedirectFrom(new NavProps(singleton(new Location(0, [defaultPage]))), "/", true, empty()), routes, AppAuthentication(empty())]))], react.createElement(Context.Provider, {
        value: cachedQueryParamsContext,
    }, ...children))], react.createElement(Context_1.Provider, {
        value: patternInput[1],
    }, ...children_1))]))));
}, undefined, undefined, "Of");

function uriGuiMonitoring(action) {
    return endpoint(toText(printf("GuiMonitoring/%s"))(action));
}

function sendMonitoringRequest(uri, exceptionObject) {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (getCurrentUser().then((_arg) => (((user_1) => ((requestBody) => ((url) => fetchAs(user_1, url, singleton(new Types_HttpRequestHeaders(11, ["application/json"])), ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [unboxAndStringify(requestBody)])])))))(_arg)(exceptionObject)(uri))))));
    pr.then(void 0, ((x) => {
        console.error(some("couldn\'t send error info"), x);
    }));
}

const uriError = uriGuiMonitoring("RegisterError");

window.onerror = ((message, source, lineno, colno, error) => {
    const error_1 = error;
    const patternInput = (error_1 == null) ? [message, "<no stack>"] : [error_1.toString(), error_1.stack];
    const msg = patternInput[0];
    if (contains(msg, ofArray(["ResizeObserver loop limit exceeded", "ResizeObserver loop completed with undelivered notifications."]), {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    })) {
    }
    else {
        sendMonitoringRequest(uriError, new GuiExceptionInfo(msg, source, lineno, colno, patternInput[1]));
    }
});

const uriUnhandledRejection = uriGuiMonitoring("RegisterUnhandledRejection");

window.onunhandledrejection = ((event) => {
    let matchValue;
    const event_1 = event;
    sendMonitoringRequest(uriUnhandledRejection, (matchValue = event_1.reason, isException(matchValue) ? (new GuiUnhandledRejectionInfo(((event_1.reason.toString()) + "\n") + event_1.reason.stack)) : (new GuiUnhandledRejectionInfo(toString(event_1.reason)))));
});

function styleProvider(children) {
    const props = {
        layer: true,
    };
    return react.createElement(StyleProvider, props, ...children);
}

const root = (() => {
    const hot = module.hot;
    return ((!(hot == null) && !(hot.data == null)) && !(hot.data.root == null)) ? hot.data.root : client.createRoot(document.getElementById("app"));
})();

root.render(styleProvider([wrap(App(empty()))]));

if (!(module.hot == null)) {
    module.hot.accept();
    module.hot.dispose((data) => {
        data.root = root;
    });
}

